// Helpers for the now-PRIVATE `trade-screenshots` bucket (Part 4 security fix).
// New uploads store the object PATH (e.g. "<uid>/<ts>.png"). Older rows may hold a
// legacy public URL; we extract the path from those so they keep displaying.
import { supabase } from '@/integrations/supabase/client';

const BUCKET = 'trade-screenshots';
const PUBLIC_MARKER = '/storage/v1/object/public/trade-screenshots/';

/** Normalize a stored value to a storage object path (or pass through a non-storage URL). */
export function tradeScreenshotPath(value?: string | null): string | null {
  if (!value) return null;
  const i = value.indexOf(PUBLIC_MARKER);
  if (i >= 0) return decodeURIComponent(value.slice(i + PUBLIC_MARKER.length));
  return value; // already a path (new uploads) or an external/signed URL
}

/**
 * Resolve a short-lived signed URL for displaying a private trade screenshot.
 * Returns null when there is nothing to show or the user lacks access.
 */
export async function resolveTradeScreenshotUrl(value?: string | null): Promise<string | null> {
  const path = tradeScreenshotPath(value);
  if (!path) return null;
  // Already a full URL we can't sign (e.g. a previously generated signed URL) — use as-is.
  if (/^https?:\/\//i.test(path)) return path;
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 3600);
  if (error) {
    console.error('[tradeScreenshot] failed to sign url:', error.message);
    return null;
  }
  return data?.signedUrl ?? null;
}
